export default "__VITE_ASSET__497c829b__"